export const parseCurrencyToFloat = (str) => {
    // Remove "R$", pontos e espaçamentos
    let clean = str.replace(/\s|R\$|\./g, '').replace(',', '.');
    return parseFloat(clean);
}